import './main.less';
import PropTypes from 'prop-types';
import React from 'react';
import cn from 'classname';
import noop from 'lodash/noop';
import flatten from 'lodash/flatten';
import Row from './row';
import { tableViewType } from '../../list';

import Pagination from '../../../shared/pagination';

const propTypes = {
	table: PropTypes.object,
	intl: PropTypes.func,
	sortByColumn: PropTypes.func,
	can: PropTypes.func,
	pagination: PropTypes.object,
	gotoPage: PropTypes.func,
	isIndexing: PropTypes.bool
};

const Table = (props) =>
	<div className="table-container">
		<table className="simple-table threads-table">
			<thead className="simple-table__head font-roboto-medium">
				<tr>
					{props.table.headers.map((header, i) =>
						<th
							key={i}
							className={cn({
								'sort-header': header.direction,
								active: props.table.sortedColumn.index === header.index,
								[props.table.sortedColumn.direction]:
									props.table.sortedColumn.index === header.index && props.table.sortedColumn.direction,
								[header.className]: header.className
							})}
							onClick={() => (header.direction ? props.sortByColumn(header.index) : noop)}
						>
							{props.intl(header.title)}
						</th>
					)}
				</tr>
			</thead>
			<tbody
				className={cn({
					'simple-table__body': true,
					'table-indexing': props.isIndexing,
					'support-table-indexing': props.isIndexing
				})}
			>
				{props.table.view === tableViewType.list && props.table.rows.map((row, i) => (
					<Row key={i} row={row} {...props} />
				))}

				{props.table.view === tableViewType.group && getGroupedRows(props)}
			</tbody>
		</table>
		<Pagination pagination={props.pagination} gotoPage={props.gotoPage} />
	</div>;

// functions
const getGroupedRows = props => {
	let res = [];

	const [ unanswered, inWork ] = props.table.rows;
	const { pagination: { total, currentPage } } = props;

	if (unanswered.data.length) {
		res = [].concat(res, makeGroupRow({
			groupRow: unanswered,
			totalRows: unanswered.data.length,
			shouldShowGroupHeader: true,
			props
		}));
	}

	if (inWork.data.length) {
		const totalRows = total - unanswered.data.length;
		res = [].concat(res, makeGroupRow({
			groupRow: inWork,
			totalRows: totalRows,
			shouldShowGroupHeader: currentPage === 1,
			props
		}));
	}

	return res;
};

Table.propTypes = propTypes;
export default Table;

// functions
const makeGroupRow = ({
	groupRow,
	totalRows,
	shouldShowGroupHeader,
	props
}) => {
	const res = [];

	shouldShowGroupHeader && res.push(
		<tr key={groupRow.name} className={`group--${groupRow.className}`}>
			<td colSpan="9">
				<span className="title font-roboto-bold">{props.intl(groupRow.name)}</span>
				<span className="count">{totalRows}</span>
			</td>
		</tr>
	);

	res.push(
		flatten(
			groupRow.data.map((entity, i) => <Row key={i} row={entity} className={`row--${groupRow.className}`} {...props} />)
		)
	);

	return res;
};



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/threads/components/table/main.js